import DocumentItem from './DocumentItem'

export default class MatchingItem extends DocumentItem {
    constructor(term = '', definition = '', term_image = '', definition_image = '') {
        super(term, definition)
        this.term_image = term_image
        this.definition_image = definition_image
    }
}
